import { FC } from "react";
import { Box, ButtonBase, Typography, useTheme } from "@mui/material";
import { ChevronRightRounded, WhatsApp } from "@mui/icons-material";
import { PatientHexAvatar } from "../../../../components/ui";
import { Patient } from "../../../../services/patient.service";
import { phoneMask, whatsappUrl } from "../patient-format";

type Props = {
  patient: Patient;
  onOpen: () => void;
};

/** Linha de paciente no mobile (avatar + nome + telefone + chevron). */
const PatientMobileCard: FC<Props> = ({ patient, onOpen }) => {
  const theme = useTheme();

  return (
    <ButtonBase
      onClick={onOpen}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "14px",
        p: "14px 16px",
        backgroundColor: "background.paper",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "14px",
        textAlign: "left",
        width: "100%",
      }}
    >
      <PatientHexAvatar name={patient.name} size={42} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "text.primary", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {patient.name}
        </Typography>
        {patient.phone && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>{phoneMask.onValue(patient.phone)}</Typography>
            {whatsappUrl(patient.phone) && (
              <Box
                component="span"
                role="link"
                aria-label="Abrir conversa no WhatsApp"
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(whatsappUrl(patient.phone), "_blank", "noopener,noreferrer");
                }}
                sx={{ display: "inline-flex", color: "#25D366", cursor: "pointer" }}
              >
                <WhatsApp sx={{ fontSize: 16 }} />
              </Box>
            )}
          </Box>
        )}
      </Box>
      <ChevronRightRounded sx={{ fontSize: 20, color: "text.disabled", flexShrink: 0 }} />
    </ButtonBase>
  );
};

export default PatientMobileCard;
